/*
 * *****************************************************************************
 *  Copyright (C) 2020 Testsigma Technologies Inc.
 *  All rights reserved.
 *  ****************************************************************************
 */

export enum Platform {
  Android = "Android",
  iOS = "iOS",
  Linux = "Linux",
  Mac = "Mac",
  Windows = "Windows"
}
